import { createAction } from 'Lib/reduxUtils';

import { ThirdParty } from 'Containers/ModalManager/modals/EmailVerification/types';

import {
  // Send email
  CANCEL_EMAIL_VERIFY,
  // Websocket
  EMAIL_COLLECTION_SETTINGS_RECEIVED,
  // Remove email
  REMOVE_EMAIL,
  REMOVE_EMAIL_ERROR,
  REMOVE_EMAIL_SUCCESS,
  RESET_GOOGLE_TOKEN,
  // Account recovery
  RESET_SEND_RECOVERY_EMAIL_STATE,
  RESET_VALIDATE_EMAIL_OTP_STATE,
  SEND_EMAIL,
  SEND_EMAIL_CLEAR_ERROR_RESPONSE,
  SEND_EMAIL_ERROR,
  SEND_EMAIL_SUCCESS,
  SEND_RECOVERY_EMAIL,
  SEND_RECOVERY_EMAIL_ERROR,
  SEND_RECOVERY_EMAIL_SUCCESS,
  // Login
  SET_EMAIL_AUTH_STATE,
  SET_EMAIL_OTP_LENGTH,
  SET_MARKETING_EMAIL_OPTIONS,
  SET_MASKED_EMAIL,
  SET_SECOND_FACTOR_THIRD_PARTY,
  // OTP
  VALIDATE_EMAIL_OTP_ERROR,
  VALIDATE_EMAIL_OTP_SUCCESS,
  VALIDATE_GOOGLE_TOKEN_ERROR,
  // Google Token
  VALIDATE_GOOGLE_TOKEN_SUCCESS,
  VERIFY_EMAIL,
  // Verify email
  VERIFY_EMAIL_ERROR,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_TYPE_GOOGLE,
  VERIFY_EMAIL_TYPE_OTP,
} from './constants';

export const sendEmail = createAction(SEND_EMAIL, (email: string) => ({ email }));
export const sendEmailSuccess = createAction(SEND_EMAIL_SUCCESS);
export const sendEmailError = createAction(SEND_EMAIL_ERROR, (error: any) => ({ error }));
export const clearErrorResponse = createAction(SEND_EMAIL_CLEAR_ERROR_RESPONSE);

export const verifyEmailOtp = createAction(VERIFY_EMAIL, () => ({
  type: VERIFY_EMAIL_TYPE_OTP,
  googleIdToken: undefined,
}));
export const verifyEmailGoogle = createAction(VERIFY_EMAIL, (googleIdToken: string) => ({
  googleIdToken,
  type: VERIFY_EMAIL_TYPE_GOOGLE,
}));
export const verifyEmailSuccess = createAction(VERIFY_EMAIL_SUCCESS, (email?: string) => ({
  email,
  type: VERIFY_EMAIL_SUCCESS,
}));
export const verifyEmailError = createAction(VERIFY_EMAIL_ERROR);
export const cancelEmailVerification = createAction(CANCEL_EMAIL_VERIFY);

export const removeEmail = createAction(REMOVE_EMAIL, (token: string) => ({ token }));
export const removeEmailSuccess = createAction(REMOVE_EMAIL_SUCCESS);
export const removeEmailError = createAction(REMOVE_EMAIL_ERROR);

// Account Recovery
export const sendRecoveryEmail = createAction(
  SEND_RECOVERY_EMAIL,
  (email: string, from: string) => ({ email, from })
);
export const sendRecoveryEmailSuccess = createAction(SEND_RECOVERY_EMAIL_SUCCESS);
export const sendRecoveryEmailError = createAction(SEND_RECOVERY_EMAIL_ERROR, (error: any) => ({
  error,
}));
export const resetSendRecoveryEmailState = createAction(RESET_SEND_RECOVERY_EMAIL_STATE);

// Websocket
export const emailCollectionSettingsReceived = createAction(
  EMAIL_COLLECTION_SETTINGS_RECEIVED,
  (emailCollectionSettings: Record<string, any>) => emailCollectionSettings
);

// MFA UI
export const setEmailAuthState = createAction(SET_EMAIL_AUTH_STATE, (emailAuthState: string) => ({
  emailAuthState,
}));
export const setMarketingEmailOptions = createAction(
  SET_MARKETING_EMAIL_OPTIONS,
  (payload: Record<string, any>) => payload
);
export const setEmailOtpLength = createAction(SET_EMAIL_OTP_LENGTH, (otpLength: number) => ({
  otpLength,
}));
export const setMaskedEmail = createAction(SET_MASKED_EMAIL, (maskedEmail: string) => ({
  maskedEmail,
}));
export const setSecondFactorThirdParty = createAction(
  SET_SECOND_FACTOR_THIRD_PARTY,
  (secondFactorThirdParty: ThirdParty) => ({ secondFactorThirdParty })
);

// OTP
export const validateEmailOtpSuccess = createAction(VALIDATE_EMAIL_OTP_SUCCESS);
export const validateEmailOtpError = createAction(VALIDATE_EMAIL_OTP_ERROR, (error: any) => ({
  error,
}));
export const resetValidateEmailOtpState = createAction(RESET_VALIDATE_EMAIL_OTP_STATE);

// Google Token
export const validateGoogleTokenSuccess = createAction(VALIDATE_GOOGLE_TOKEN_SUCCESS);
export const validateGoogleTokenError = createAction(VALIDATE_GOOGLE_TOKEN_ERROR, (error: any) => ({
  error,
}));

export const resetGoogleToken = createAction(RESET_GOOGLE_TOKEN);
